import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  actionsloading: false
})

export function yearinfoReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_YEAR_INFO:
      return {
        ...state,
        actionsloading: true
      }
    case actionTypes.FETCH_YEAR_INFO_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false
      }
    default:
      return state;
  }
}